import React, { useMemo, useState } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { formatDateMMDDYY } from '../../utilities/dateHelpers';
import { colors } from '../../constants/index';

function dateFormatter(params) {
    return params ? formatDateMMDDYY(new Date(params)) : '';
}

const SiteOpsTable = ({
    projects,
    columnDefinitions,
    containerHeight = '350px',
}) => {
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
    });

    const columns = useMemo(() => {
        let cols = [];
        if (projects) {
            cols = columnDefinitions.map((c) =>
                c.type === 'date'
                    ? { ...c, valueFormatter: dateFormatter, width: 125 }
                    : { ...c }
            );
        }
        return cols;
    }, [projects]);

    const tableRows = useMemo(
        () =>
            projects.map((p, index) => {
                const row = { ...p, id: index };
                for (let f in row) {
                    const col = columnDefinitions.find((c) => c.field === f);
                    if (col && col.type === 'date' && row[f]) {
                        row[f] = new Date(row[f]);
                    }
                }
                return row;
            }),
        [projects]
    );

    return (
        <div style={{ height: containerHeight, width: '100%' }}>
            <DataGridPro
                rows={tableRows}
                columns={columns}
                columnVisibilityModel={columnVisibilityModel}
                onColumnVisibilityModelChange={(newModel) =>
                    setColumnVisibilityModel(newModel)
                }
                pageSizeOptions={[500, 500, 500]}
                density="compact"
                sx={{
                    '& .MuiDataGrid-columnHeaderTitle': {
                        fontWeight: '700',
                        whiteSpace: 'normal',
                        lineHeight: 'normal',
                        color: colors.skyfallDark,
                    },
                    '& .MuiDataGrid-virtualScrollerContent': {
                        background: '#fcfcfc',
                    },
                    '& .MuiDataGrid-columnHeader': {
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        height: 'unset !important',
                    },
                    '& .MuiDataGrid-columnHeader:focus': {
                        outlineOffset: '-2px',
                    },
                    '& .MuiDataGrid-root': {
                        whiteSpace: 'normal !important',
                        wordWrap: 'break-word !important',
                    },
                    '& .MuiDataGrid-cell:focus': {
                        outlineOffset: '-2px',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        maxHeight: '124px !important',
                    },

                    '& .MuiDataGrid-footerContainer': {
                        maxHeight: '24px !important',
                        minHeight: '24px !important',
                        fontSize: '0.75rem',
                        background: 'white',
                    },
                    '& .MuiDataGrid-filler': {
                        background: 'white',
                    },
                    '& .MuiDataGrid-overlay': {
                        background: 'white',
                    },
                }}
            />
        </div>
    );
};

export default SiteOpsTable;
